import React, { Component } from 'react';
import SumaContexto from '../../contexto/SumaContexto';
import { withRouter } from "react-router-dom";
import { withCookies } from 'react-cookie';
import { Button, Row, Col, Spin, Tooltip, Tag, Popconfirm } from 'antd';
import { MailOutlined, EditOutlined, StopOutlined, CheckOutlined, ReloadOutlined } from '@ant-design/icons';
import Constantes from '../../utilidades/Constantes'
import ServicioDatosConstantes from '../../servicios/ServicioDatosConstantes'
import ServicioEntidad from '../../servicios/ServicioEntidad'
import ServicioPais from '../../servicios/ServicioPais'
import queryString from 'query-string';
import Utilidades from '../../utilidades/Utilidades'
import Validadores from '../../utilidades/Validadores';


class VerSubUsuarioDependencia extends Component {

    static contextType = SumaContexto;

    ENUM_COMPONENTE = {
        CARGANDO: 1,
        VER: 2,
        NO_DISPONIBLE: 3
    }

    state = {
        cargando: true,
        idUsuario: 0,
        subUsuario: null,
        componente: this.ENUM_COMPONENTE.CARGANDO,
        usuario: null
    };

    constructor(props) {
        super(props);
        this.servicioDatosConstantes = new ServicioDatosConstantes(props);
        this.servicioEntidad = new ServicioEntidad(props);
        this.servicioPais = new ServicioPais(props);
        this.callbackEditarUsuario = props.callbackEditarUsuario;
        this.callbackActivarUsuario = props.callbackActivarUsuario;
        this.callbackEnviarCorreoActivacion = props.callbackEnviarCorreoActivacion;
        this.callbackEnviarCorreoCambioContrasena = props.callbackEnviarCorreoCambioContrasena;
    }

    // -----------------------------------------------------------------------
    // --- CARGA DATOS INICIALES ---------------------------------------------
    // -----------------------------------------------------------------------
    async cargarDatosIniciales() {

        let params = this.props.location.search;
        let urlparametros = queryString.parse(params);
        let idUsuario = 0;

        if (urlparametros.id !== undefined && !isNaN(parseInt(urlparametros.id))) {
            idUsuario = parseInt(urlparametros.id);
        }

        // Validando que el usuario es ENTIDAD
        let usr = await this.servicioEntidad.usuarioValido();
        this.setSumaState({ componente: (usr !== null ? this.ENUM_COMPONENTE.VER : this.ENUM_COMPONENTE.NO_DISPONIBLE) });

        if (usr !== null && idUsuario !== 0) {
            this.setSumaState({ cargando: true, idUsuario: idUsuario });
            let subUsuario = await this.servicioEntidad.obtenerUsuarioDependencia(idUsuario);
            if (subUsuario) {
                let pais = await this.servicioPais.obtenerPaisPromesa(subUsuario.datoPersonal.ciudad.idPais);
                let departamento = await this.servicioPais.obtenerDepartamentoPromesa(subUsuario.datoPersonal.ciudad.idDepartamento);
                if (pais && departamento) {
                    subUsuario.pais = pais.pais;
                    subUsuario.departamento = departamento.departamento;
                    this.setSumaState({ usuario: usr, cargando: false, subUsuario: subUsuario, });
                }
            }
        }
    }

    componentDidMount() {
        this._isMounted = true;
        this.cargarDatosIniciales();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    setSumaState(valores) {
        if (this._isMounted) {
            this.setState(valores);
        }
    }

    render() {
        const { subUsuario, componente, usuario } = this.state;

        const wrapperCol = {
            xs: { span: 21, offset: 1 },
            sm: { span: 11, offset: 1 },
        };

        return (
            <div>
                {(componente === this.ENUM_COMPONENTE.VER) ?
                    (
                        <>
                            <Spin tip="Por favor espera..." size="large" spinning={this.state.cargando}>
                                <Row>
                                    <Col sm={12}>
                                        <h3 className="titulo inline-block">Usuario:</h3> &nbsp;&nbsp;&nbsp;
                                        <h3 className="inline-block">{subUsuario !== null ? subUsuario.datoPersonal.nombreCompleto : ""}</h3>
                                    </Col>
                                </Row>
                                <h3 className="sub-titulo-separador margen-bottom">Información básica</h3>
                                <div className="seccion-datos">
                                    <Row className="fila">
                                        <Col  {...wrapperCol}>
                                            <Row>
                                                <Col sm={12}>
                                                    <label className="titulo-etiqueta">Rol:</label>
                                                </Col>
                                                <Col sm={12}>
                                                    <span>{subUsuario !== null ? subUsuario.rol.rol : ""}</span>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col  {...wrapperCol}>
                                            <Row>
                                                <Col sm={12}>
                                                    <label className="titulo-etiqueta">Cargo:</label>
                                                </Col>
                                                <Col sm={12}>
                                                    <span>{subUsuario !== null ? subUsuario.usuarioDependencia.cargo : ""}</span>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                    <Row className="fila">
                                        <Col  {...wrapperCol}>
                                            <Row>
                                                <Col sm={12}>
                                                    <label className="titulo-etiqueta">Tipo de documento:</label>
                                                </Col>
                                                <Col sm={12}>
                                                    <span>{subUsuario !== null ? subUsuario.datoPersonal.tipoDocumento.tipoDocumento : ""}</span>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col  {...wrapperCol}>
                                            <Row>
                                                <Col sm={12}>
                                                    <label className="titulo-etiqueta">Número de documento:</label>
                                                </Col>
                                                <Col sm={12}>
                                                    <span>{subUsuario !== null ? subUsuario.datoPersonal.numeroDocumento : ""}</span>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                    <Row className="fila">
                                        <Col  {...wrapperCol}>
                                            <Row>
                                                <Col sm={12}>
                                                    <label className="titulo-etiqueta">Lugar de expedición:</label>
                                                </Col>
                                                <Col sm={12}>
                                                    <span>{subUsuario !== null ? subUsuario.datoPersonal.lugarExpedicion : ""}</span>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col  {...wrapperCol}>
                                            <Row>
                                                <Col sm={12}>
                                                    <label className="titulo-etiqueta">Fecha de expedición:</label>
                                                </Col>
                                                <Col sm={12}>
                                                    <span>{subUsuario !== null ? subUsuario.datoPersonal.fechaExpedicionFormatoEspanol : ""}</span>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                    <Row className="fila">
                                        <Col  {...wrapperCol}>
                                            <Row>
                                                <Col sm={12}>
                                                    <label className="titulo-etiqueta">Correo electrónico:</label>
                                                </Col>
                                                <Col sm={12}>
                                                    <span>{subUsuario !== null ? subUsuario.datoPersonal.correoElectronico : ""}</span>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col  {...wrapperCol}>
                                            <Row>
                                                <Col sm={12}>
                                                    <label className="titulo-etiqueta">Estado:</label>
                                                </Col>
                                                <Col sm={12}>
                                                    <Tag color={
                                                        (subUsuario !== null && subUsuario.estadoUsuario.id === Constantes.ENUMS.ESTADO_USUARIO.ACTIVO.id)
                                                            ?
                                                            'green'
                                                            :
                                                            (subUsuario !== null && subUsuario.estadoUsuario.id === Constantes.ENUMS.ESTADO_USUARIO.INACTIVO.id
                                                                ?
                                                                'volcano'
                                                                :
                                                                (subUsuario !== null && subUsuario.estadoUsuario.id === Constantes.ENUMS.ESTADO_USUARIO.CREADO.id
                                                                    ?
                                                                    'geekblue'
                                                                    :
                                                                    ''
                                                                )
                                                            )
                                                    } key={subUsuario !== null ? subUsuario.estadoUsuario.estadoUsuario : ""}>
                                                        {subUsuario !== null ? subUsuario.estadoUsuario.estadoUsuario.toUpperCase() : ""}
                                                    </Tag>

                                                    {subUsuario !== null && subUsuario.cambioContrasena
                                                        ?
                                                        <Tooltip title="El usuario tiene pendiente un cambio de contraseña">
                                                            <Tag color="purple" key="Cambio Contraseña">CONTRASEÑA</Tag>
                                                        </Tooltip>
                                                        :
                                                        <></>
                                                    }

                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                    <Row className="fila">
                                        <Col  {...wrapperCol}>
                                            <Row>
                                                <Col sm={12}>
                                                    <label className="titulo-etiqueta">Móvil:</label>
                                                </Col>
                                                <Col sm={12}>
                                                    <span>{subUsuario !== null ? subUsuario.datoPersonal.celular : ""}</span>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col  {...wrapperCol}>
                                            <Row>
                                                <Col sm={12}>
                                                    <label className="titulo-etiqueta">Teléfono:</label>
                                                </Col>
                                                <Col sm={12}>
                                                    <span>{subUsuario !== null ? subUsuario.datoPersonal.telefono : ""}</span>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>


                                    <Row className="fila">
                                        <Col  {...wrapperCol}>
                                            <Row>
                                                <Col sm={12}>
                                                    <label className="titulo-etiqueta">País:</label>
                                                </Col>
                                                <Col sm={12}>
                                                    <span>{subUsuario !== null ? subUsuario.pais : ""}</span>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col  {...wrapperCol}>
                                            <Row>
                                                <Col sm={12}>
                                                    <label className="titulo-etiqueta">Región:</label>
                                                </Col>
                                                <Col sm={12}>
                                                    <span>{subUsuario !== null ? subUsuario.departamento : ""}</span>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>

                                    <Row className="fila">
                                        <Col  {...wrapperCol}>
                                            <Row>
                                                <Col sm={12}>
                                                    <label className="titulo-etiqueta">Ciudad:</label>
                                                </Col>
                                                <Col sm={12}>
                                                    <span>{subUsuario !== null ? subUsuario.datoPersonal.ciudad.ciudad : ""}</span>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col  {...wrapperCol}>
                                            <Row>
                                                <Col sm={12}>
                                                    <label className="titulo-etiqueta">Dirección residencia:</label>
                                                </Col>
                                                <Col sm={12}>
                                                    <span>{subUsuario !== null ? subUsuario.datoPersonal.direccion : ""}</span>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>

                                </div>


                                <h3 className="sub-titulo-separador margen-bottom margen-top">Opciones</h3>
                                <div className="seccion-datos seccion-final">

                                    {(subUsuario !== null)
                                        ?
                                        (<>
                                            <Button className="boton-opcion"
                                                icon={<EditOutlined style={{ color: '#c90a00' }} />}
                                                onClick={(e) => { this.callbackEditarUsuario(e, this.state.idUsuario) }}
                                                disabled={!Utilidades.accionPermitida(usuario, Constantes.ENUMS_MODULOS.DEPENDENCIA.ACCIONES.EDITAR_INFORMACION_SUB_USUARIO_DEPENDENCIA.id)}>
                                                Editar
                                            </Button>

                                            {(subUsuario.estadoUsuario.id === Constantes.ENUMS.ESTADO_USUARIO.ACTIVO.id)
                                                ?
                                                <Popconfirm title="Confirma desactivar el usuario?"
                                                    okText="Si"
                                                    cancelText="No"
                                                    onConfirm={(e) => {
                                                        this.setSumaState({ cargando: true });
                                                        this.callbackActivarUsuario(
                                                            e,
                                                            subUsuario.id,
                                                            subUsuario.datoPersonal.nombreCompleto,
                                                            false,
                                                            () => {
                                                                this.setSumaState({ cargando: false });
                                                                this.cargarDatosIniciales();
                                                            });

                                                    }}
                                                    disabled={!Utilidades.accionPermitida(usuario, Constantes.ENUMS_MODULOS.DEPENDENCIA.ACCIONES.DESACTIVAR_SUB_USUARIO_DEPENDENCIA.id)}
                                                >
                                                    <Button className="boton-opcion"
                                                        icon={<StopOutlined style={{ color: '#c90a00' }} />}
                                                        disabled={!Utilidades.accionPermitida(usuario, Constantes.ENUMS_MODULOS.DEPENDENCIA.ACCIONES.DESACTIVAR_SUB_USUARIO_DEPENDENCIA.id)}>
                                                        Desactivar
                                                    </Button>
                                                </Popconfirm>
                                                :
                                                <></>
                                            }

                                            {(subUsuario.estadoUsuario.id === Constantes.ENUMS.ESTADO_USUARIO.INACTIVO.id)
                                                ?
                                                <Popconfirm title="Confirma activar el sub usuario?"
                                                    okText="Si"
                                                    cancelText="No"
                                                    onConfirm={(e) => {
                                                        this.setSumaState({ cargando: true });
                                                        this.callbackActivarUsuario(
                                                            e,
                                                            subUsuario.id,
                                                            subUsuario.datoPersonal.nombreCompleto,
                                                            true,
                                                            () => {
                                                                this.setSumaState({ cargando: false });
                                                                this.cargarDatosIniciales();
                                                            });

                                                    }}
                                                    disabled={!Utilidades.accionPermitida(usuario, Constantes.ENUMS_MODULOS.DEPENDENCIA.ACCIONES.ACTIVAR_SUB_USUARIO_DEPENDENCIA.id)}
                                                >
                                                    <Button className="boton-opcion"
                                                        icon={<CheckOutlined style={{ color: '#c90a00' }} />}
                                                        disabled={!Utilidades.accionPermitida(usuario, Constantes.ENUMS_MODULOS.DEPENDENCIA.ACCIONES.ACTIVAR_SUB_USUARIO_DEPENDENCIA.id)}>
                                                        Activar
                                                    </Button>
                                                </Popconfirm>
                                                :
                                                <></>
                                            }


                                            {(subUsuario.estadoUsuario.id === Constantes.ENUMS.ESTADO_USUARIO.CREADO.id)
                                                ?
                                                (<Popconfirm title="Confirma enviar el correo de activación?"
                                                    okText="Si"
                                                    cancelText="No"
                                                    onConfirm={(e) => {
                                                        this.setSumaState({ cargando: true });
                                                        this.callbackEnviarCorreoActivacion(
                                                            e,
                                                            subUsuario.id,
                                                            subUsuario.datoPersonal.nombreCompleto,
                                                            () => {
                                                                this.setSumaState({ cargando: false });
                                                                this.cargarDatosIniciales();
                                                            });
                                                    }}
                                                    disabled={!Utilidades.accionPermitida(usuario, Constantes.ENUMS_MODULOS.DEPENDENCIA.ACCIONES.ENVIAR_CORREO_ACTIVACION_SUB_USUARIO_DEPENDENCIA.id)}
                                                >
                                                    <Button className="boton-opcion"
                                                        icon={<MailOutlined style={{ color: '#c90a00' }} />}
                                                        disabled={!Utilidades.accionPermitida(usuario, Constantes.ENUMS_MODULOS.DEPENDENCIA.ACCIONES.ENVIAR_CORREO_ACTIVACION_SUB_USUARIO_DEPENDENCIA.id)}>
                                                        Enviar correo activación
                                                    </Button>
                                                </Popconfirm>)
                                                :
                                                (
                                                    (
                                                        !Validadores.usuarioSUMAv1( subUsuario ) &&
                                                        !subUsuario.autenticaContraLDAP
                                                    ) ?

                                                        (<Popconfirm title="Confirma enviar el correo para cambio de contraseña?"
                                                            okText="Si"
                                                            cancelText="No"
                                                            onConfirm={(e) => {
                                                                this.setSumaState({ cargando: true });
                                                                this.callbackEnviarCorreoCambioContrasena(
                                                                    e,
                                                                    subUsuario.id,
                                                                    subUsuario.datoPersonal.nombreCompleto,
                                                                    () => {
                                                                        this.setSumaState({ cargando: false });
                                                                        this.cargarDatosIniciales();
                                                                    });
                                                            }}
                                                            disabled={!Utilidades.accionPermitida(usuario, Constantes.ENUMS_MODULOS.DEPENDENCIA.ACCIONES.ENVIAR_CORREO_CAMBIO_CONTRASENA_SUB_USUARIO_DEPENDENCIA.id)}
                                                        >
                                                            <Button className="boton-opcion"
                                                                icon={<ReloadOutlined style={{ color: '#c90a00' }} />}
                                                                disabled={!Utilidades.accionPermitida(usuario, Constantes.ENUMS_MODULOS.DEPENDENCIA.ACCIONES.ENVIAR_CORREO_CAMBIO_CONTRASENA_SUB_USUARIO_DEPENDENCIA.id)}>
                                                                Cambiar contraseña
                                                            </Button>
                                                        </Popconfirm>) : (<></>)
                                                )
                                            }

                                            {subUsuario.autenticaContraLDAP ?
                                                (<p><br />
                                                    Nota: El método de autenticación del usuario es contra el directorio activo del DADEP.</p>)
                                                : (<></>)
                                            }

                                        </>)
                                        :
                                        (<></>)
                                    }
                                </div>

                            </Spin>
                        </>
                    )
                    :
                    (
                        (componente === this.ENUM_COMPONENTE.CARGANDO) ?
                            (<Spin tip="Por favor espera..." className="solo-spin-cargando" size="large" />)
                            : ((componente === this.ENUM_COMPONENTE.NO_DISPONIBLE) ? (<label>Contenido no disponible. [Cod:VSUD]</label>) : (<></>))
                    )
                }

            </div>
        );
    }
}

export default withRouter(withCookies(VerSubUsuarioDependencia));